module.exports = __webpack_public_path__ + "zh_CN.json";


// WEBPACK FOOTER //
// ./src/zh_CN.json